module.exports = __webpack_public_path__ + "img/inactiveicon-kvdr.3f2394de.svg";